import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import ProjectCard from "@/components/ProjectCard";

export default function ProjectsPage() {
  const [projects, setProjects] = useState([]);
  const [donate, setDonate] = useState("");
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api.get("/projects").then(({ data }) => setProjects(data)).catch(() => {});
    api.get("/settings").then(({ data }) => setDonate(data.gofundme_url)).catch(() => {});
  }, []);

  const cats = ["All", "Protect", "Educate", "Empower"];
  const list = filter === "All" ? projects : projects.filter((p) => p.category === filter);

  return (
    <div data-testid="projects-page">
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#C1272D] mb-3">Sponsor a room</p>
        <h1 className="font-display text-5xl sm:text-6xl font-bold tracking-tight text-[#1F4D2E] max-w-3xl leading-[0.95]">Choose a project. Watch it come to life.</h1>
        <p className="text-lg text-[#4F6B54] mt-6 max-w-2xl leading-relaxed">Each project below funds a real, tangible part of our children's home. Progress numbers are updated by our staff — no guesswork, just honest impact.</p>

        <div className="flex flex-wrap gap-3 mt-10">
          {cats.map((c) => (
            <button key={c} onClick={() => setFilter(c)} data-testid={`filter-${c.toLowerCase()}`}
              className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-colors ${filter === c ? "bg-[#1F4D2E] text-white" : "bg-[#E7EDE2] text-[#1F4D2E] hover:bg-[#1F4D2E]/10"}`}>{c}</button>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
        {list.length === 0 ? (
          <p className="text-[#4F6B54] py-16 text-center" data-testid="no-projects">No projects in this category yet.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {list.map((p, i) => (
              <motion.div key={p.id} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}>
                <ProjectCard project={p} donateFallback={donate} />
              </motion.div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
